var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('span',{staticStyle:{"float":"left"}},[_vm._v(_vm._s(_vm.item.label))]),(_vm.item.isDefault)?_c('span',{staticStyle:{"float":"right","color":"#8492a6","font-size":"13px"}},[_vm._v("Default Address")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }